var irreducible = require('./irreducible');
var isBoolean = require('./isBoolean');

module.exports = irreducible('Boolean', isBoolean);



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb/lib/Boolean.js
 ** module id = 19
 ** module chunks = 0
 **/